import { useNavigate } from 'react-router-dom';
import { Header } from '../components/layout/Header';

interface Props {
  title: string;
  phase: string;
  description: string;
  breadcrumbs: string[];
}

export function PlaceholderPage({ title, phase, description, breadcrumbs }: Props) {
  const navigate = useNavigate();
  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <div className="px-8 py-12 max-w-2xl">
        <div className="text-xs uppercase tracking-widest text-navy-800/50 mb-1">Coming in {phase}</div>
        <h1 className="serif-display text-3xl text-navy-800 font-medium">{title}</h1>
        <p className="text-sm text-navy-800/70 mt-3 leading-relaxed">{description}</p>
        <div className="mt-6 p-4 bg-cream-100 border border-cream-200 rounded-sm">
          <div className="text-xs uppercase tracking-widest text-saffron-700 mb-1">Build status</div>
          <div className="text-sm text-navy-800">
            Backend endpoints already shipped in Day 3 · React UI scheduled for {phase}.
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-6 text-saffron-600 hover:text-saffron-700 text-sm font-medium"
        >
          ← Back to Director's Cockpit
        </button>
      </div>
    </>
  );
}
